import { render, staticRenderFns } from "./ChoiceBreadcrumbs.vue?vue&type=template&id=b95ae8ea&scoped=true"
import script from "./ChoiceBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./ChoiceBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95ae8ea",
  null
  
)

export default component.exports